export default "__VITE_ASSET__6f4976f2__"